/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
import scribe from './scribe';
import sessionService from './session-service';
import { toLocalizedRiotUrl } from './../utils/language';

function postJson(url, draft) {
    return $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: url,
        data: JSON.stringify(draft),
        dataType: 'json'
    });
}

function trackItemPublished(draft) {
    var isFromTemplate = isDraftFromTemplate(draft);
    scribe.sendSessionDuration(
        sessionService.getElapsedMillis(),
        isFromTemplate
    );
}

function prepareForPublish(draft) {
    draft.shippingOptions = _.filter(draft.shippingOptions, function(item) {
        return !!item.type;
    });
}

function isNullOrUndefined(val) {
    return _.isNull(val) || _.isUndefined(val);
}

function isDraftFromTemplate(draft) {
    return draft && !isNullOrUndefined(draft.templateId);
}

const publish = (draft, hasTraderaPayConsent) => {
    var deferred = $.Deferred();
    prepareForPublish(draft);
    postJson(toLocalizedRiotUrl('/selling/api/items'), {
        draft: draft,
        hasTraderaPayConsent: hasTraderaPayConsent
    })
        .then(function(data) {
            trackItemPublished(draft);
            if (data.errorCode) {
                deferred.reject(data);
            } else {
                deferred.resolve(data);
            }
        })
        .fail(function(data) {
            deferred.reject(data);
        });

    return deferred.promise();
};

export default {
    publish
};
